const initState = {
    reloadFY: false,
    reloadQuery: false,
    reloadClient: false,
    reloadUser: false,
    reloadComment: false,
    reloadDocument: false,
    reloadFolder : false,
}

export const reloadReducer = (state = initState, action) => {
    switch (action.type) {
        case 'RELOAD_DOCUMENT':
            return {
                ...state,
                reloadDocument: action.payload
            };
        case 'RELOAD_FOLDER' :
            return{
                ...state,
                reloadFolder : action.payload
            };
        case 'RELOAD_FY':
            return {
                ...state,
                reloadFY: action.payload
            };
        case 'RELOAD_USER':
            return {
                ...state,
                reloadUser: action.payload
            };
        case 'RELOAD_COMMENT':
            return {
                ...state,
                reloadComment: action.payload
            };
        case 'RELOAD_CLIENT':
            return {
                ...state,
                reloadClient: action.payload
            };
        case 'RELOAD_QUERY':
            return {
                ...state,
                reloadQuery: action.payload
            };
        case 'RESET_SELECTIONS':
            return initState;
        default:
            return state;
    }
};